import dayjs, { Dayjs } from "utils/dayjs"

import { Guid } from "@/types"
import { InvoicingType } from "config/constants"
import ReservationInvoicePosition, { IGetReservationInvoicePositionDto } from "./ReservationInvoicePosition"
import CalculationAdjustment, { IGetCalculationAdjustmentDto } from './CalculationAdjustment'
import { InvoiceRateCalculationType } from "./OutgoingInvoice"

export interface IGetReservationPricingDetailsDto {
    orderTypeId?: Guid | null
    originCountryCode?: string
    termsOfPaymentCode?: string | null
    invoiceHeaderText?: string | null
    invoiceFooterText?: string | null
    headerSectionConfirmationText?: string | null
    footerSectionConfirmationText?: string | null
    rentalContractHeaderText?: string | null
    rentalContractFooterText?: string | null
    automaticInvoicing?: boolean | null
    invoiceBeforeShipping?: boolean | null
    invoiceRateCalculationType?: InvoiceRateCalculationType | null
    invoicingType?: InvoicingType | null
    invoicePositions?: IGetReservationInvoicePositionDto[] | null
    calculationAdjustments?: IGetCalculationAdjustmentDto[] | null
    machineInsuranceIncluded?: boolean | null
    machineInsuranceExcess?: number | null
    invoiceBlocked?: boolean | null
    invoiceBlockedBy?: Guid | null
    invoiceBlockedDate?: string | null
    invoiceBlockedReason?: string | null
}

export default class ReservationPricingDetails {
    orderTypeId?: string
    originCountryCode?: string
    termsOfPaymentCode?: string
    invoiceHeaderText?: string
    invoiceFooterText?: string
    headerSectionConfirmationText?: string
    footerSectionConfirmationText?: string
    rentalContractHeaderText?: string | null
    rentalContractFooterText?: string | null
    automaticInvoicing: boolean | null
    invoiceBeforeShipping: boolean | null
    invoiceRateCalculationType?: InvoiceRateCalculationType
    invoicingType: InvoicingType | null
    invoicePositions?: ReservationInvoicePosition[]
    calculationAdjustments?: CalculationAdjustment[]
    machineInsuranceIncluded: boolean
    machineInsuranceExcess?: number
    invoiceBlocked: boolean
    invoiceBlockedBy?: Guid
    invoiceBlockedDate?: Dayjs
    invoiceBlockedReason?: string

    constructor(dto: IGetReservationPricingDetailsDto) {
        this.orderTypeId = dto.orderTypeId ?? undefined
        this.originCountryCode = dto.originCountryCode ?? undefined
        this.termsOfPaymentCode = dto.termsOfPaymentCode ?? undefined
        this.invoiceHeaderText = dto.invoiceHeaderText ?? undefined
        this.invoiceFooterText = dto.invoiceFooterText ?? undefined
        this.headerSectionConfirmationText = dto.headerSectionConfirmationText ?? undefined
        this.footerSectionConfirmationText = dto.footerSectionConfirmationText ?? undefined
        this.rentalContractHeaderText = dto.rentalContractHeaderText ?? undefined
        this.rentalContractFooterText = dto.rentalContractFooterText ?? undefined
        this.automaticInvoicing = dto.automaticInvoicing ?? null
        this.invoiceBeforeShipping = dto.invoiceBeforeShipping ?? null
        this.invoiceRateCalculationType = dto.invoiceRateCalculationType ?? undefined
        this.invoicingType = dto.invoicingType ?? null
        this.invoicePositions = dto.invoicePositions?.map(ipDto => new ReservationInvoicePosition(ipDto)) || undefined
        this.calculationAdjustments = dto.calculationAdjustments?.map(caDto => new CalculationAdjustment(caDto)) || undefined
        this.machineInsuranceIncluded = dto.machineInsuranceIncluded ?? false
        this.machineInsuranceExcess = typeof dto.machineInsuranceExcess === "number" ? dto.machineInsuranceExcess : undefined
        this.invoiceBlocked = dto.invoiceBlocked ?? false
        this.invoiceBlockedBy = dto.invoiceBlockedBy ?? undefined
        this.invoiceBlockedDate = dto.invoiceBlockedDate ? dayjs(dto.invoiceBlockedDate) : undefined
        this.invoiceBlockedReason = dto.invoiceBlockedReason ?? undefined
    }

    get hasInvoicingSettings(): boolean {
        return this.automaticInvoicing !== null || this.invoicingType !== null
    }
}
